// removed by extract-text-webpack-plugin
module.exports = {"page":"index-module__page___W8EhE","page-row":"index-module__page-row___1MOeE","pageRow":"index-module__page-row___1MOeE"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/auth/consent/index.module.scss
// module id = 1680
// module chunks = 146